import { Lock } from 'lucide-react';
import { Label } from './Label';
import { Input } from './Input';

interface LockedFieldProps {
  label: string;
  value: string;
  hint?: string;
  required?: boolean;
}

/** Read-only field styled like a disabled input (Edit User / locked org pattern). */
export function LockedField({
  label,
  value,
  hint,
  required,
}: LockedFieldProps) {
  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-1.5 text-gray-700">
        <Lock className="w-3 h-3 shrink-0" aria-hidden />
        {label}
        {required && <span className="text-red-500"> *</span>}
      </Label>
      {hint && <p className="text-xs text-gray-500">{hint}</p>}
      <Input
        value={value}
        title={value}
        disabled
        readOnly
        tabIndex={-1}
        className="bg-gray-100 text-gray-700 cursor-not-allowed truncate"
      />
    </div>
  );
}
